import { toggleIn } from "./hikvisionControl";
import { OptionCard, StepBody, StepHeader, StepNav } from "./HikvisionWizardParts";

// One key disarm - picks the Hikvision alarm outputs to control. The site output that drives
// them is chosen on the next step (HikvisionStepOutput).
const HikvisionStepOneKey = ({ ioOutputs, selectedOutputIds, setSelectedOutputIds, onNext, onBack, isLastStep }) => (
    <>
        <StepHeader title="Which Hikvision outputs would you like to control?" subtitle="You'll choose the site output that controls them next" />
        <StepBody>
            {ioOutputs.length === 0 && (
                <p style={{ color: "var(--text-label)", fontSize: "14px", textAlign: "center", marginTop: "2rem" }}>
                    No alarm outputs were found on this Hikvision.
                </p>
            )}
            {ioOutputs.map(output => (
                <OptionCard
                    key={output.id}
                    title={output.id}
                    subtitle={output.ioType}
                    selected={selectedOutputIds.includes(output.id)}
                    onClick={() => setSelectedOutputIds(prev => toggleIn(prev, output.id))}
                />
            ))}
        </StepBody>
        <StepNav
            onBack={onBack}
            onNext={onNext}
            nextDisabled={selectedOutputIds.length === 0}
            nextLabel={isLastStep ? "Link Hikvision" : "Next"}
            nextIcon={isLastStep ? "pi pi-link" : "pi pi-arrow-right"}
        />
    </>
);

export default HikvisionStepOneKey;
